import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
    prop: "description",
    label: _ctx.label
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_cascader, {
        "model-value": _ctx.modelValue,
        onChange: _ctx.setValue,
        options: _ctx.skills
      }, {
        default: _withCtx(({ node, data }) => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$filters.capitalize(data.value)), 1),
          (!node.isLeaf)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(data.children.length) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model-value", "onChange", "options"])
    ]),
    _: 1
  }, 8, ["label"])), [
    [_directive_loading, _ctx.loadingSkills]
  ])
}